module.exports = __webpack_public_path__ + "img/nav.b5bccb03.png";